
import { defineComponent, ref, onMounted } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import ChangeLogTable from "./ChangeLogTable.vue";

export default defineComponent({
  name: "change-logs-index",
  components: {
    ChangeLogTable,
  },
  setup() {
    onMounted(() => {
      setCurrentPageBreadcrumbs("资产变动记录", ["财务管理"]);
    });

    const activeTab = ref("balance");

    return {
      activeTab,
    };
  },
});
